<template>
  <div class="w-full p-0" :class="topClasses">
    <div v-if='!grid' class="overflow-visible">
      <div class="h-12 overflow-x-scroll-x overflow-y-hidden">
        <apollo-query :query='listPacksQuery'
                      class='flex flex-row h-12'
                      fetch-policy='cache-and-network'
                      :variables='{nextToken:"",size:100}'>
          <template v-slot='{ result: { loading, error, data }, isLoading }'>
            <div v-if='isLoading || loading' class="spinner text-xl mt-8 mb-4" />

            <button class="focus:outline-none relative h-12 justify-center mx-1 w-24 md:w-48 flex-none"
                    @click='onSelectPack({id:"upload",name:"upload",items:[]})'
                    :class='isSelected({id:"upload"}) ? "pbc-instant-button-selected" : "pbc-instant-button"'
                    >
              <upload class="text-white" :size='32' />
              <span class="text-white">Upload Image</span>
            </button>

            <button class="focus:outline-none relative h-12 justify-center mx-1 w-16 md:w-24 flex-none"
                    :class='isSelected(pack) ? "pbc-instant-button-selected" : "pbc-instant-button"'
                    v-for='pack in filterPacks(((data||{}).getPacks||{}).items||[])'
                    :key='pack.name'
                    @click='onSelectPack(pack)'>

              <img class="p-2 overflow-hidden object-contain w-24 h-12 md:w-48" :src='makeUrl(pack.thumbnailImage)' loading="lazy" />

              <div class="absolute left-0 right-0 bottom-0 top-0">
                <div class="mx-auto mt-1 tracking-tight font-semibold self-center text-white text-wrap pack-text-shadow">{{pack.name}}</div>
              </div>

            </button>

          </template>

        </apollo-query>

      </div>
      <div v-if='!selectPack'
              class="flex flex-row h-20 pt-2"
              :key='selectedPack.id'>

        <image-uploader v-if='selectedPack.id === "upload"'
                        class="w-64 h-20"
                        game-id='gameId'
                        @uploaded='onUpload'
                        :is-short-mode='true'
                        :already-uploaded='uploadedImages'
                        @select='onSelectUploadedImage'
                        />

        <!--
        <div class="h-full">
          <pbc-button class="flex flex-row justify-center border shadow-sm rounded hover:border-gray-600 pbc-primary-color h-full" @click='back'>
            <chevron-left :size='32' />
          </pbc-button>
        </div>
        -->

        <div v-for='({layer,toysheet},i) in allToysheets' :key='i' class="h-20 flex flex-row">

          <instant-view-toys ref='instantViewToys'
                             :toys='toysheet.toys'
                             class="mx-0"
                             @select='onSelectToy(layer, toysheet, $event)'>
            <template #toy='{toy}'>
              <div class="absolute left-0 top-0 flex select-none" :class='toysBlocked[toy.id] ? "text-yellow-300" : ""' >
                <star :size='16'  />
                <span class="pack-text-shadow font-bold text-white text-xs" :class='toysBlocked[toy.id] ? "text-yellow-300" : ""'>{{toy.name}}</span>

              </div>
            </template>
          </instant-view-toys>
        </div>

        <div class="flex flex-row h-20 overflow-x-scroll overflow-y-hidden">
          <div v-for='({layer,toysheet},i) in allToysheets' :key='i' class="flex flex-row y-16">

            <pbc-button v-if='layer.id === "background"' @click='clearLayer(layer)'>None</pbc-button>
            <div class="flex flex-row">
              <instant-view-images ref='instantViewSprites'
                                    :images='toysheet.sprites' 
                                    class="mx-0"
                                    @select='onSelectImage(layer, toysheet, $event.image)'
                                        />

              <div v-for='{spritesheet} in toysheet.spritesheets' :key='spritesheet.id'>
                <instant-view-spritesheet ref='instantViewSpritesheet' :spritesheet='spritesheet.id'
                                          @select='onSelectSprite(layer, toysheet, spritesheet, $event.image)'
                                          class="mx-0"
                                          />

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div v-else class="w-full h-full flex flex-col">
      <div class="w-full flex-none overflow-scroll flex flex-row">
        <apollo-query :query='listPacksQuery'
                      :class='selectPack ? "" : "pack-selected"'
                      fetch-policy='cache-and-network'
                      :tag='undefined'
                      class='instant-packs-view-grid'
                      :variables='{from:0,size:100}'>
          <template v-slot='{ result: { loading, error, data }, isLoading }'>
            <button class="instant-pack-button"
                    :class='selectedPackButtonClasses({id:"upload"})'
                    @click='onSelectPack({id:"upload",name:"upload",items:[]})'
                    >
              <upload :size='32' />
              Upload Image
            </button>

            <button class="instant-pack-button"
                    v-for='pack in (((data||{}).getPacks||{}).items||[])'
                    :key='pack.name'
                    :class='selectedPackButtonClasses(pack)'
                    @click='onSelectPack(pack)'>

              <img class="overflow-hidden object-contain w-full" :src='makeUrl(pack.thumbnailImage)' loading="lazy" :class='!selectPack ? "h-12" : "h-24"' />

              <div class="text-sm font-thin mx-auto tracking-tight self-center text-white text-wrap pack-text-shadow">{{pack.name}}</div>

            </button>

            <div v-if='isLoading || loading' class="spinner text-xl mt-8 mb-4" />
          </template>

        </apollo-query>

      </div>
      <div v-if='!selectPack'
               class='grow overflow-y-scroll overflow-x-hidden'
              :key='selectedPack.id'>

        <image-uploader v-if='selectedPack.id === "upload"'
                        class="w-64"
                        game-id='gameId'
                        @uploaded='onUpload'
                        :is-short-mode='true'
                        :already-uploaded='uploadedImages'
                        @select='onSelectUploadedImage'
                        />

        <template v-for='({layer,toysheet},i) in allToysheets'>

          <instant-view-toys ref='instantViewToys'
                            :toys='toysheet.toys'
                            class="mb-4"
                            classes='p-2 grid grid-cols-2 gap-2'
                            :key='i'
                            @select='onSelectToy(layer, toysheet, $event)'>
            <template #toy='{toy}'>
              <div class="absolute left-0 top-0 flex select-none" :class='toysBlocked[toy.id] ? "text-yellow-300" : ""' >
                <star :size='16'  />
                <span class="text-black text-xs" :class='toysBlocked[toy.id] ? "text-yellow-300" : ""'>{{toy.name}}</span>

              </div>
            </template>
          </instant-view-toys>

          <instant-view-images ref='instantViewSprites'
                                :images='toysheet.sprites' 
                                class="overflow-scroll mx-0"
                                :key='i'
                                @select='onSelectImage(layer, toysheet, $event.image)'
                                    />

          <template v-for='{spritesheet} in toysheet.spritesheets'>
            <instant-view-spritesheet ref='instantViewSpritesheet' :spritesheet='spritesheet.id'
                                      @select='onSelectSprite(layer, toysheet, spritesheet, $event.image)'
                                      :key='spritesheet.id'
                                      :type='makeSpritesheetViewType(selectedPack, toysheet, spritesheet)'
                                      />

          </template>

        </template>

      </div>

    </div>
  </div>
</template>
<script>
import Upload from '@icons/Upload.vue';
import ImageUploader from '@ui/molecules/ImageUploader.vue';
import Star from '@icons/Star.vue';
import Treeutil from '@/edit/tree/treeutil.js';
import Partutil from '@/edit/tree/partutil.js';
import Toydata from '@/edit/tree/toydata.js';
import { flatten, cloneDeep, range } from 'lodash';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import { listPacksQuery } from '@/gql/Queries.js';
import { ApolloQuery } from 'vue-apollo';
import Check from '@icons/Check.vue';
import InstantViewSpritesheet from '@/ui/molecules/InstantViewSpritesheet.vue';
import InstantViewImages from '@/ui/molecules/InstantViewImages.vue';
import InstantViewToys from '@/ui/organisms/InstantViewToys.vue';

const tmpToysBlocked = {};
export default {
  inject:['api'],
  props:{
    partutil:{
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    grid: {
      type: Boolean,
      default: false
    },
    selectedLayers: {
      type: Object,
      required: true
    },
    layers: {
      type: Object,
      required: true
    },
    holderData:{
      type: Object,
      required: true
    },
    direction: {
      type: String,
      default: 'vertical'
    }
  },
  mounted() {
    this.$emit('mode', 'choosepack');
  },
  methods: {
    selectedPackButtonClasses(pack) {
                      //:class='selectPack ? "" : "pack-selected"'
                    //:class='isSelected(pack) ? "pbc-instant-button" : ""'
      const classes = [];
      if (this.isSelected(pack)) {
        classes.push('pbc-instant-button');
      }
      if (!this.selectPack) {
        classes.push('pack-selected');
      }
      return classes;
    },
    makeSpritesheetViewType(pack, toysheet, spritesheet) {
      return pack.name.toLowerCase().indexOf("meme") !== -1 ? "big" : "small"
    },
    onUpload(data) {
      this.uploadedImages.push(data);
    },
    onSelectUploadedImage({id}) {
      const layer = {
        id:'default',
        name:'Foreground',
        zindex:1,
        projection:'orthogonal',
        direction:'rightdown'
      }

      this.$emit('select', {
        data:{
          layer,
          image:{id},
        },
        type:'upload'
      });
    },
    reset() {
      this.back();
    },
    clearLayer(layer) {
      this.$emit("clear-layer", layer);
    },
    back() {
      this.selectedPack = this.emptyPack;
      this.selectedImage = {};
      this.selectedToy = {};
      this.$emit("mode", "choosepack");
    },
    makeUrl(thumbnailImage) {
      return this.api.makeSpritesheetUrlEditor(thumbnailImage);
    },
    onSelectPack(pack) {
      this.selectedPack = pack;
      this.$emit("mode", "chosepack");

      this.$ana.track({
        eventCategory: 'pack',
        eventAction: pack.name
      });
    },
    onSelectToy(layer, toysheet, toy) {

      if (this.toysBlocked[toy.id]) {
        (this.$refs.instantViewToys||[]).forEach( (ivs) => {
          ivs.deselect();
        });
        return;
      }

      const selectedToy = {
        layer,
        toysheet,
        toy
      }
      this.selectedImage = {};
      (this.$refs.instantViewSpritesheet||[]).forEach( (ivs) => {
        ivs.deselect();
      });
      (this.$refs.instantChooseSprites||[]).forEach( (ivs) => {
        ivs.deselect();
      });
      this.$emit("mode", "placing");

      this.$emit('select', {
        data:selectedToy,
        type:'toy'
      });
   },
    onSelectImage(layer, toysheet, image) {
      const data = {
        image,
        toysheet
      };
      (this.$refs.instantViewToys||[]).forEach( (ivt) => {
        ivt.deselect();
      });
      (this.$refs.instantViewSpritesheet||[]).forEach( (ivs) => {
        ivs.deselect();
      });
      this.$emit("mode", "placing");

      this.$emit('select', {
        data,
        type:'sprite'
      });
    },
    onSelectSprite(layer, toysheet, spritesheet, image) {

      const data = {
        image,
        spritesheet,
        layer,
        toysheet
      }
      this.selectedToy = {};
      (this.$refs.instantViewToys||[]).forEach( (ivt) => {
        ivt.deselect();
      });
      (this.$refs.instantViewSprites||[]).forEach( (ivt) => {
        ivt.deselect();
      });

      this.$emit('select', {
        data,
        type:'spritesheet'
      });

    },
    isSelected(pack) {
      if (this.selectedPack.id === pack.id) {
        return true;
      } else {
        return false;
      }
    },
    filterPacks(packs) {
      return packs.filter( (pack) => {
        return pack.items.filter( ({layer}) => {
        //return pack.layers.filter( (layer) => {
          return Object.keys(this.selectedLayers).length === 0 ? true : this.selectedLayers[layer.id];
        }).length;
      });
    }
  },
  data() {
    const emptyPack = {
      layers:[]
    }
    const gamedata = this.partutil.gamedata.gamedata;
    if (typeof(gamedata.uploadedImages) === 'undefined') {
      this.$set(gamedata, 'uploadedImages', []);
    }
    const uploadedImages = gamedata.uploadedImages;
    return {
      selectedPack: emptyPack,
      emptyPack,
      listPacksQuery,
      selectedImage:{},
      selectedToy:{},
      toysBlocked:tmpToysBlocked,
      toyLimits:{},
      uploadedImages
    }
  },
  components: {
    ApolloQuery,
    InstantViewSpritesheet,
    InstantViewImages,
    InstantViewToys,
    Star,
    Upload,
    ImageUploader,
  },
  computed:{
    topClasses() {
      const classes = [];
      if (!this.grid) {
        classes.push('h-32');
      } else {
      }
      if (this.direction === 'vertical') {
        classes.push('instant-choose-pack-vertical');
        classes.push('h-full');
      } else {
        classes.push('instant-choose-pack-horizontal');
      }
      return classes;
    },
    hasSelectedGridItem() {
      return !!this.selectedImage.image || !!this.selectedToy.toy;
    },
    allToysheets() {
      return flatten(this.selectedPack.items.map( ({toysheets,layer}) => {
        return toysheets.map( (inToysheet) => {
          const toysheet = cloneDeep(inToysheet);
          toysheet.toys = toysheet.toys.map( ({limit,toy}) => {
            let disabled = false;
            return {toy,disabled};
          });
          return {layer,toysheet}
        });
      }));
    },
    selectPack() {
      return this.selectedPack === this.emptyPack;
    }
  },
  watch:{
    hasSelectedGridItem(nv) {
      if (nv) {
        this.$emit('hide-for-placing');
      }
    },
    selectedPack: {
      handler(nv) {
        ((this.selectedPack||{}).items||[]).forEach( (item) => {
          item.toysheets.forEach( (toysheet) => {
            toysheet.toys.forEach( ({limit,toy}) => {
              this.toyLimits[toy.id] = limit;
            });
          });
        })
      }

    }
  }
}
</script>
<style>
.pack-text-shadow {
  text-shadow: 0 2px 4px rgba(0,0,0,1.0);
}
.dropzone {
  padding: 0px !important;
  margin: 0px !important;
  height: auto !important;
  min-height: auto !important;
}
.dz-message {
  padding: 0px !important;
  margin: 0px !important;
}
</style>

